/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BatchJobSummaryResponse } from './BatchJobSummaryResponse';
import {
    BatchJobSummaryResponseFromJSON,
    BatchJobSummaryResponseFromJSONTyped,
    BatchJobSummaryResponseToJSON,
} from './BatchJobSummaryResponse';

/**
 * 
 * @export
 * @interface PagedBatchJobSummaryResponse
 */
export interface PagedBatchJobSummaryResponse {
    /**
     * 
     * @type {Array<BatchJobSummaryResponse>}
     * @memberof PagedBatchJobSummaryResponse
     */
    items: Array<BatchJobSummaryResponse>;
    /**
     * 
     * @type {number}
     * @memberof PagedBatchJobSummaryResponse
     */
    count: number;
}

/**
 * Check if a given object implements the PagedBatchJobSummaryResponse interface.
 */
export function instanceOfPagedBatchJobSummaryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedBatchJobSummaryResponseFromJSON(json: any): PagedBatchJobSummaryResponse {
    return PagedBatchJobSummaryResponseFromJSONTyped(json, false);
}

export function PagedBatchJobSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedBatchJobSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BatchJobSummaryResponseFromJSON)),
        'count': json['count'],
    };
}

export function PagedBatchJobSummaryResponseToJSON(value?: PagedBatchJobSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(BatchJobSummaryResponseToJSON)),
        'count': value.count,
    };
}

